import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import InputWithLabel from "components/forms/InputWithLabel";
import InputText from "components/forms/InputText";
import ButtonPrimary from "components/buttons/ButtonPrimary";
import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import Tip from "components/other/Tip";

import crossIcon from "assets/img/icons/red-cross-icon.svg";
import sadIcon from "assets/img/icons/sad-icon.svg";
import smileIcon from "assets/img/icons/smile-icon.svg";
import streakIcon from "assets/img/icons/flash-icon-indigo.svg";

const ClaimReward = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;
  min-height: 256px;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const Text = styled.div`
  line-height: 125%;
`;

const CodeForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

const ButtonWrap = styled.div`
  display: flex;
`;

const Warning = styled.div`
  margin-top: -5px;

  font-size: 13px;
  font-weight: 500;
  color: ${css.ERROR_RED};
`;

const ResultBox = styled.div`
  width: 100%;
  margin-top: ${css.VERTICAL_BOX_MARGIN};
  margin-bottom: ${css.VERTICAL_BOX_MARGIN};

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const ResultBoxIcon = styled.div`
  width: 44px;
  min-width: 44px;
  height: 44px;
`;

const ResultBoxText = styled.div`
  font-size: 19px;
  font-weight: 500;
  text-align: center;
`;

const ResultBoxSubText = styled.div`
  text-align: center;
`;

const ResultBoxButton = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN};
`;

const RequiredStreakLine = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;
const RequiredStreakText = styled.div``;

const SmallStreakBox = styled.div`
  height: 30px;
  padding: 0px 12px;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: 15px;

  transition: 0.2s;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

const StreakIcon = styled.div``;

const Icon = styled.div`
  width: 16px;
  min-width: 16px;
  height: 16px;
`;

const Streak = styled.div`
  font-size: 15px;
  font-weight: 500;
`;

const LoadingWrap = styled.div`
  padding: 10px 0 35px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

export default ({
  code,
  onCodeInputChange,
  warning,
  errorMessage,
  claimReward,
  rewardNotFoundBox,
  closeResultBox,
  rewardsAlreadyPaidBox,
  smallStreakBox,
  streakRequired,
  loadingClaimReward,
  resultBox,
  resultOrder,
  resultReward,
}) => {
  return (
    <ClaimReward>
      <Text>
        Enter the code you received in our Telegram channel. If you are among
        the fastest, you will receive a reward.
      </Text>
      {!rewardNotFoundBox &&
        !rewardsAlreadyPaidBox &&
        !smallStreakBox &&
        !loadingClaimReward &&
        !resultBox && (
          <CodeForm>
            <InputWithLabel
              label="Code"
              width="100%"
              // marginTop={css.VERTICAL_BOX_MARGIN_MEDIUM}
            >
              <InputText
                type="text"
                name="code"
                value={code}
                placeholder="Enter code"
                onChange={onCodeInputChange}
                maxLength={4}
                warning={warning}
                width="200px"
              />
            </InputWithLabel>
            <ButtonWrap>
              <ButtonPrimary onClick={claimReward}>Claim</ButtonPrimary>
            </ButtonWrap>
            {errorMessage && <Warning>{errorMessage}</Warning>}
          </CodeForm>
        )}
      {rewardNotFoundBox && (
        <ResultBox>
          <ResultBoxIcon>
            <img src={crossIcon} style={{ width: "100%" }} />
          </ResultBoxIcon>
          <ResultBoxText>
            This code does not correspond to any active reward.
          </ResultBoxText>
          <ResultBoxButton>
            <ButtonPrimarySmall onClick={closeResultBox}>
              Try Again
            </ButtonPrimarySmall>
          </ResultBoxButton>
        </ResultBox>
      )}
      {rewardsAlreadyPaidBox && (
        <ResultBox>
          <ResultBoxIcon>
            <img src={sadIcon} style={{ width: "100%" }} />
          </ResultBoxIcon>
          <ResultBoxText>
            The rewards for this code have already been paid out.
          </ResultBoxText>
          <ResultBoxButton>
            <ButtonPrimarySmall onClick={closeResultBox}>
              Close
            </ButtonPrimarySmall>
          </ResultBoxButton>
        </ResultBox>
      )}
      {smallStreakBox && (
        <ResultBox>
          <ResultBoxIcon>
            <img src={sadIcon} style={{ width: "100%" }} />
          </ResultBoxIcon>
          <ResultBoxText>
            This reward requires a higher activity streak.
          </ResultBoxText>
          <RequiredStreakLine>
            <RequiredStreakText>Required</RequiredStreakText>
            <SmallStreakBox>
              <StreakIcon>
                <Icon>
                  <img src={streakIcon} style={{ width: "100%" }} />
                </Icon>
              </StreakIcon>
              <Streak>{streakRequired}</Streak>
            </SmallStreakBox>
            <Tip
              tipId="activityStreak"
              tip="To claim this bonus, you need to have a higher activity streak bonus.<br><br>For each day you find coins, your Activity Streak Bonus increases by one percentage point.<br><br>If you miss a day, your bonus resets back to 0%, and you'll start over.<br/><br/><a href='https://help.scalelup.com/en/articles/11320560-activity-streak-bonus' target='_blank' class='tooltip-link'>Learn more</a>"
              clickable
            ></Tip>
          </RequiredStreakLine>
          <ResultBoxButton>
            <ButtonPrimarySmall onClick={closeResultBox}>
              Close
            </ButtonPrimarySmall>
          </ResultBoxButton>
        </ResultBox>
      )}
      {loadingClaimReward && (
        <ResultBox>
          <LoadingWrap>
            <BoxLoadingSpinner height="50px" />
            <ResultBoxText>
              We are processing the results, please wait.
            </ResultBoxText>
          </LoadingWrap>
        </ResultBox>
      )}
      {resultBox && !resultReward && (
        <ResultBox>
          <ResultBoxIcon>
            <img src={sadIcon} style={{ width: "100%" }} />
          </ResultBoxIcon>
          <ResultBoxText>
            Unfortunately, you are not among the winners this time.
          </ResultBoxText>
          <ResultBoxSubText>
            The order in which you redeemed the code:{" "}
            {resultOrder ? resultOrder : "10+"}
          </ResultBoxSubText>
          <ResultBoxButton>
            <ButtonPrimarySmall onClick={closeResultBox}>
              Close
            </ButtonPrimarySmall>
          </ResultBoxButton>
        </ResultBox>
      )}
      {resultBox && resultReward && (
        <ResultBox>
          <ResultBoxIcon>
            <img src={smileIcon} style={{ width: "100%" }} />
          </ResultBoxIcon>
          <ResultBoxText>
            Congratulations, you have received a reward of $
            {resultReward.toFixed(2)} USD!
          </ResultBoxText>
          <ResultBoxSubText>
            The order in which you redeemed the code: {resultOrder}
          </ResultBoxSubText>
          <ResultBoxButton>
            <ButtonPrimarySmall onClick={closeResultBox}>
              Close
            </ButtonPrimarySmall>
          </ResultBoxButton>
        </ResultBox>
      )}
    </ClaimReward>
  );
};
